export const defaultAPIQueryData = {
  creds: [],
}
